var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownwardGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 39.4C23.8334 39.4 23.6568 39.3659 23.4701 39.2978C23.2834 39.2296 23.1101 39.1136 22.9501 38.95L9.0501 25.05C8.7501 24.7567 8.6001 24.4083 8.6001 24.005C8.6001 23.6017 8.7501 23.25 9.0501 22.95C9.3501 22.65 9.7001 22.5 10.1001 22.5C10.5001 22.5 10.8501 22.65 11.1501 22.95L22.5001 34.3V9.5C22.5001 9.0641 22.6447 8.70513 22.9338 8.4231C23.223 8.14103 23.5814 8 24.0088 8C24.4363 8 24.7918 8.14375 25.0751 8.43125C25.3584 8.71875 25.5001 9.075 25.5001 9.5V34.3L36.8501 22.95C37.1501 22.65 37.5001 22.5 37.9001 22.5C38.3001 22.5 38.6501 22.6474 38.9501 22.9421C39.2501 23.2368 39.4001 23.5868 39.4001 23.9921C39.4001 24.3974 39.2501 24.75 38.9501 25.05L25.0501 38.95C24.8834 39.1167 24.7152 39.2333 24.5455 39.3C24.3758 39.3667 24.194 39.4 24.0001 39.4Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownwardGreen);
export default __webpack_public_path__ + "static/media/arrow_downward_green.29775ab3512b050f613dddfa39eb5986.svg";
export { ForwardRef as ReactComponent };